module.exports = __webpack_public_path__ + "img/ic_device_connect.ff456e22.png";